import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WelcomeScreen from './pages/WelcomeScreen';
import LoginScreen from './pages/LoginScreen';
import PhotoUploadScreen from './pages/PhotoUploadScreen';
import SimulationPreviewScreen from './pages/SimulationPreviewScreen';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<WelcomeScreen />} />
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/upload" element={<PhotoUploadScreen />} />
        <Route path="/preview" element={<SimulationPreviewScreen />} />
      </Routes>
    </Router>
  );
}

export default App;
